import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {toastClose} from '~/modules/toast/actions';
import KEYS from '~/misc/keys';

import css from './index.css';

class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.toastCloseUI = (uriToast, contextToast) => props.dispatch(toastClose(uriToast, contextToast));
  }

  render() {
    if (!this.props.contextToast) {
      return null;
    }
    return (
      <div className={cs(css.toastWrap)}>
        <div className={css.block} data-qa='toastPop'>
          <div className={css.static}>
            <p dangerouslySetInnerHTML={{__html: this.props.contextToast}} />
          </div>
          <span className={cs('toast-close', css.closeButton)} onClick={this.close}>×</span>
        </div>
      </div>
    );
  }

  onKeyPress(e) {
    if (e.keyCode === KEYS.ESC) {
      this.close();
    }
  }

  close() {
    this.toastCloseUI(this.props.uriToast, false);
  }
}

export default connect(({toast}) => ({
  uriToast: toast.uriToast,
  contextToast: toast.contextToast,
}), null)(Toast);




// WEBPACK FOOTER //
// ./src/components/Toast/index.js